"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadOverdueDict = exports.messageTemplate = exports.overdueStatus = exports.vehicleStatus = exports.contractStatus = exports.contractLockContractStatus = exports.messageSendStatus = exports.letterReminderSendStatus = exports.overdueCollectType = exports.overdueLevel = void 0;
const complex_data_1 = require("complex-data");
const index_1 = require("./../config/index");
const select_1 = __importDefault(require("../api/select"));
const config_1 = require("./config");
const ComplexSelect_1 = __importDefault(require("@/class/ComplexSelect"));
const overdue_1 = __importDefault(require("../api/overdue"));
exports.overdueLevel = new complex_data_1.SelectList({
    name: '逾期级别',
    list: [
        {
            value: '正常',
            label: '正常',
            color: index_1.color.success,
            reverseColor: '#000'
        },
        {
            value: 'M0',
            label: 'M0',
            color: index_1.color.success,
            reverseColor: '#000'
        },
        {
            value: 'M1',
            label: 'M1',
            color: index_1.color.success,
            reverseColor: '#000'
        },
        {
            value: 'M2',
            label: 'M2',
            color: index_1.color.warning,
            reverseColor: '#000'
        },
        {
            value: 'M3+',
            label: 'M3+',
            color: index_1.color.danger,
            reverseColor: '#000'
        },
    ]
});
exports.overdueCollectType = new complex_data_1.SelectList({
    name: '催收类型',
    list: [
        {
            value: '1',
            label: '电催',
        },
        {
            value: '2',
            label: '上门',
        }
    ]
});
exports.letterReminderSendStatus = new complex_data_1.SelectList({
    name: '发送状态',
    list: [
        {
            value: '0',
            label: '未发送',
        },
        {
            value: '1',
            label: '已发送',
        }
    ]
});
exports.messageSendStatus = new complex_data_1.SelectList({
    name: '短信发送状态',
    list: [
        {
            value: '1',
            label: '已发送',
        },
        {
            value: '2',
            label: '未发送',
        }
    ]
});
exports.contractLockContractStatus = new complex_data_1.SelectList({
    name: '契约锁合同状态',
    list: [
        {
            value: 'NOT_GENERATE',
            label: '未生成',
            color: index_1.color.disabled,
            status: 0
        },
        {
            value: 'IN_FORMATION',
            label: '生成中',
            color: index_1.color.text,
            status: 10
        },
        {
            value: 'GENERATED_ERROR',
            label: '生成失败',
            color: index_1.color.danger,
            status: -11
        },
        {
            value: 'GENERATED',
            label: '已生成',
            color: index_1.color.success,
            status: 20
        },
        {
            value: 'SIGNING',
            label: '签署中',
            color: index_1.color.text,
            status: 30
        },
        {
            value: 'RECALLED',
            label: '撤回',
            color: index_1.color.danger,
            status: -31
        },
        {
            value: 'REJECTED',
            label: '已退回',
            color: index_1.color.danger,
            status: -32
        },
        {
            value: 'COMPLETE',
            label: '已完成',
            color: index_1.color.success,
            status: 40
        },
        {
            value: 'EXPIRED',
            label: '已截止签署',
            color: index_1.color.danger,
            status: -41
        },
        {
            value: 'FILLING',
            label: '拟定中',
            color: index_1.color.danger,
            status: -42
        },
        {
            value: 'INVALIDING',
            label: '作废中',
            color: index_1.color.danger,
            status: -43
        },
        {
            value: 'INVALIDED',
            label: '已作废',
            color: index_1.color.danger,
            status: -44
        },
        {
            value: 'FORCE_END',
            label: '强制结束',
            color: index_1.color.danger,
            status: -45
        }
    ]
});
exports.contractStatus = new ComplexSelect_1.default({
    name: '合同状态',
    list: [],
    getData() {
        return (0, config_1.loadDefaultDictList)(select_1.default.contractStatus);
    }
});
exports.vehicleStatus = new ComplexSelect_1.default({
    name: '车辆状态',
    list: [],
    getData() {
        return (0, config_1.loadDefaultDictList)(select_1.default.vehicleStatus);
    }
});
exports.overdueStatus = new ComplexSelect_1.default({
    name: '逾期状态',
    list: [],
    getData() {
        return (0, config_1.loadDefaultDictList)(select_1.default.overdueStatus);
    }
});
exports.messageTemplate = new ComplexSelect_1.default({
    name: '消息模板',
    list: [],
    getData() {
        return new Promise((resolve, reject) => {
            overdue_1.default.messageTemplate.require({
                smsType: '1'
            }).then(res => {
                const list = res.data.data.map((item) => {
                    return {
                        value: item.id,
                        label: item.templateContent
                    };
                });
                resolve({ status: 'success', list: list });
            }).catch(err => {
                reject(err);
            });
        });
    }
});
const loadOverdueDict = function () {
    return Promise.allSettled([exports.contractStatus.$loadData(), exports.vehicleStatus.$loadData(), exports.overdueStatus.$loadData()]);
};
exports.loadOverdueDict = loadOverdueDict;
